import { translateSubElementString } from "../../../../../../../../../utils";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DataTable } from "../../../../../../../../../components/DataTable";
import * as React from "react";

function WaterUsageAndTreatmentTab({ data }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.scopeThree.inputs.purchasedGoodsAndServices.waterUsageAndTreatment"
  });
  const { t: globalTranslation } = useTranslation("translation");

  const columns = useMemo(() => [
      {
        header: t("gridColumns.usageType"),
        accessorKey: "usageType",
        size: 350
      },
      {
        header: `${t("gridColumns.totalConsumption")} (${globalTranslation("measures.cubicMeters")})`,
        accessorKey: "totalConsumption",
        size: 260
      },
      {
        header: translateSubElementString("reportsPage.scopeThree.inputs.purchasedGoodsAndServices.waterUsageAndTreatment.gridColumns.totalEmissions"),
        accessorKey: "totalEmissions",
        size: 250
      }
    ],
    [t, globalTranslation]
  );

  const mapData = (data) => {
    return data && data.waterUsageTreatment ? [{
      usageType: t("waterUsage"),
      totalConsumption: data.waterUsageTreatment.waterUsageConsumption ?? "",
      totalEmissions: data.waterUsageTreatment.waterUsageEmission ?? ""
    }] : [];
  };

  return (
    <DataTable
      data={mapData(data)}
      columns={columns}
      containerHeight="340px"
    />
  );
}

export default WaterUsageAndTreatmentTab;